import { useState } from "react";
import Button from "components/button";
import classnames from "classnames";
import styles from "./reportButton.module.css";
import settings from "client.settings.json";
import { translate } from "reducers/i18n";

const ReportButton = ({ type, tokens }) => {
  const [isExporting, setIsExporting] = useState(false);

  const handleExport = async () => {
    try {
      setIsExporting(true);
      const token = tokens.pdf;
      const a = document.createElement("a");
      a.href = `${settings.api}/download/${token}`;
      a.setAttribute("download", "");
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      setIsExporting(false);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <Button
        className={classnames(
          styles.root,
          "bold d-flex align-items-center shadow-sm text-dark  mr-3",
          { [styles.exporting]: isExporting }
        )}
        disabled={isExporting}
        iconName="cil-spreadsheet"
        color="light"
        onClick={handleExport}
        size="sm"
        type="button"
        iconClassName=""
      >
        {isExporting ? "Generating" : translate("compose_download_copy")}
      </Button>
    </>
  );
};

export default ReportButton;
